import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LogisticsChat from './LogisticsChat';
import './Marketplace.css';

const Marketplace = ({ onBack, user }) => {
  const { t } = useTranslation();
  const [selectedApp, setSelectedApp] = useState(null);
  const [showLogisticsChat, setShowLogisticsChat] = useState(false);

  const apps = [
    {
      id: 1,
      name: t('marketplace.logisticsService', '物流服务'),
      description: t('marketplace.logisticsDesc', '专业的物流配送服务，支持同城配送和跨城运输'),
      icon: '🚚',
      category: 'logistics',
      price: '免费',
      rating: 4.8,
      reviews: 1280
    },
    {
      id: 2,
      name: t('marketplace.accountingAssistant', '会计助手'),
      description: t('marketplace.accountingDesc', '智能会计助手，自动化财务记账和报表生成'),
      icon: '📊',
      category: 'finance',
      price: '¥199/月',
      rating: 4.7,
      reviews: 856
    },
    {
      id: 3,
      name: t('marketplace.supplyChainAssistant', '供应链和采购助手'),
      description: t('marketplace.supplyChainDesc', '智能供应链管理，优化采购流程和库存控制'),
      icon: '📦',
      category: 'supply',
      price: '¥299/月',
      rating: 4.6,
      reviews: 634
    },
    {
      id: 4,
      name: t('marketplace.financeAssistant', '金融助手'),
      description: t('marketplace.financeDesc', '专业的金融服务，提供融资、理财和风险管理'),
      icon: '💰',
      category: 'finance',
      price: '¥149/月',
      rating: 4.9,
      reviews: 1523
    },
    {
      id: 5,
      name: t('marketplace.hrAssistant', '人力资源助手'),
      description: t('marketplace.hrDesc', '智能人力资源管理，招聘、考勤、薪酬一站式服务'),
      icon: '👥',
      category: 'hr',
      price: '¥179/月',
      rating: 4.5,
      reviews: 412
    }
  ];

  const handleAppClick = (app) => {
    if (app.id === 1) {
      setShowLogisticsChat(true);
    } else {
      setSelectedApp(app);
    }
  };

  const handleBack = () => {
    if (showLogisticsChat) {
      setShowLogisticsChat(false);
    } else if (selectedApp) {
      setSelectedApp(null);
    } else if (onBack) {
      onBack();
    }
  };

  const handleInstall = (appId) => {
    console.log('Installing app:', appId);
  };

  return (
    <div className="marketplace-container">
      {showLogisticsChat ? (
        <LogisticsChat onBack={handleBack} user={user} />
      ) : (
        <>
          <div className="marketplace-header">
            <button 
              className="marketplace-back-btn" 
              onClick={handleBack}
              type="button"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>
            <h1 className="marketplace-title">{t('marketplace.title', '市场')}</h1>
          </div>

          {!selectedApp ? (
            <div className="marketplace-content">
              <div className="marketplace-apps-grid">
                {apps.map(app => (
                  <div 
                    key={app.id} 
                    className="marketplace-app-card"
                    onClick={() => handleAppClick(app)}
                  >
                    <div className="marketplace-app-icon">{app.icon}</div>
                    <div className="marketplace-app-info">
                      <h3 className="marketplace-app-name">{app.name}</h3>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="marketplace-app-detail">
              <div className="marketplace-app-detail-icon">{selectedApp.icon}</div>
              <h2 className="marketplace-app-detail-name">{selectedApp.name}</h2>
              <p className="marketplace-app-detail-description">{selectedApp.description}</p>
              
              <div className="marketplace-app-detail-stats">
                <div className="marketplace-stat-item">
                  <span className="marketplace-stat-label">{t('marketplace.rating', '评分')}</span>
                  <span className="marketplace-stat-value">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                    </svg>
                    {selectedApp.rating}
                  </span>
                </div>
                <div className="marketplace-stat-item">
                  <span className="marketplace-stat-label">{t('marketplace.reviews', '评价')}</span>
                  <span className="marketplace-stat-value">{selectedApp.reviews}</span>
                </div>
                <div className="marketplace-stat-item">
                  <span className="marketplace-stat-label">{t('marketplace.price', '价格')}</span>
                  <span className="marketplace-stat-value">{selectedApp.price}</span>
                </div>
              </div>

              <div className="marketplace-app-detail-features">
                <h3>{t('marketplace.features', '功能特点')}</h3>
                <ul>
                  <li>{t('marketplace.feature1', '功能1')}</li>
                  <li>{t('marketplace.feature2', '功能2')}</li>
                  <li>{t('marketplace.feature3', '功能3')}</li>
                </ul>
              </div>

              <button 
                className="marketplace-install-btn"
                onClick={() => handleInstall(selectedApp.id)}
              >
                {t('marketplace.install', '安装应用')}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Marketplace;
